import * as Sentry from "@sentry/browser";
import {
    breadcrumbsIntegration,
    browserProfilingIntegration,
    browserSessionIntegration,
    browserTracingIntegration
} from "@sentry/browser";
import { readConfigJson } from "@modules/utils/read-config-json";
import type { ISentryConfigDTO } from "dtos";

/**
 * Initialize Sentry error tracking.
 */
export function initializeSentry(): void {
    const sentryConfig = readConfigJson<ISentryConfigDTO>("sentry-config");

    Sentry.init({
        initialScope: {
            extra: sentryConfig.user ? {
                "accountId": sentryConfig.user.accountId
            } : undefined,
            user: sentryConfig.user ? {
                id: sentryConfig.user.id
            } : undefined
        },
        integrations: [
            breadcrumbsIntegration(),
            browserTracingIntegration(),
            browserSessionIntegration(),
            browserProfilingIntegration(),
        ],
        enableLogs: true,
        dsn: sentryConfig.frontendDsn,
        release: "Stages@" + sentryConfig.release,
        environment: sentryConfig.environment,
        sampleRate: sentryConfig.sampleRate,
        tracesSampleRate: sentryConfig.traceSampleRate,
        allowUrls: sentryConfig.allowUrls
    });
}
